import Swiper from "swiper/bundle";
import "swiper/css/bundle";

//ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
//swiper functionその1
//ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
jQuery(function ($) {
 var heroSwiper = new Swiper("#topHero .swiper-container", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,

  speed: 1500,
  autoplay: {
   delay: 8000,
   disableOnInteraction: false,
   autoplayDisableOnInteraction: false,
  },
  effect: "fade",
  fadeEffect: {
   crossFade: true,
  },

  navigation: {
   nextEl: ".swiper-button-next",
   prevEl: ".swiper-button-prev",
  },
  on: {
   init: function () {
    $("#topHero .swiper-slide-prev,#topHero swiper-slide-duplicate-prev, #topHero .swiper-slide-next, #topHero .swiper-slide-duplicate-next").find(".slide-title").removeClass("maskPlay");
    $("#topHero .swiper-slide-active").find(".slide-title").addClass("reveal--now");
    $("#topHero .swiper-slide-active")
     .find(".slide-title")
     .each(function (i) {
      $(this)
       .delay(i * 200)
       .queue(function () {
        $(this).addClass("maskPlay");
        $(this).removeClass("reveal--now").dequeue();
       });
     });
   },
  }, //on
 });

 // 切り替わりのアニメーションが終了したとき
 heroSwiper.on("slideChangeTransitionEnd", function () {
  $("#topHero .swiper-slide").find(".slide-title").removeClass("maskPlay");
  $("#topHero .swiper-slide-active").find(".slide-title").addClass("reveal--now");

  $("#topHero .swiper-slide-active")
   .find(".slide-title")
   .each(function (i) {
    $(this)
     .delay(i * 200)
     .queue(function () {
      $(this).addClass("maskPlay");

      $(this).removeClass("reveal--now").dequeue();
     });
   });
 });
});
//ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
//swiper functionその2
//ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー

jQuery(function ($) {
 var slidenum = $("#topSpecial .swiper-container .swiper-slide").length;

 $("#topSpecial .topSpecial-inner").addClass("slidenum-" + slidenum);

 if (slidenum > 3) {
  var specialSwiper = new Swiper("#topSpecial .swiper-container", {
   pagination: { el: ".swiper-pagination", clickable: true },
   loop: true,
   slidesPerView: 1,
   watchOverflow: false,
   speed: 500,
   autoplay: {
    delay: 8000,
    disableOnInteraction: false,
    autoplayDisableOnInteraction: false,
   },
   spaceBetween: 15,
   grabCursor: true,
   breakpoints: {
    480: {
     slidesPerView: 3,
    },
   },
  });
 } else if (slidenum == 3) {
  console.log(slidenum);
  var specialSwiper = new Swiper("#topSpecial .swiper-container", {
   slidesPerView: 1,
   watchOverflow: false,
   speed: 500,
   grabCursor: true,
   loop: true,
   autoplay: {
    delay: 8000,
    disableOnInteraction: false,
    autoplayDisableOnInteraction: false,
   },
   pagination: { el: ".swiper-pagination", clickable: true },
   spaceBetween: 15,
   breakpoints: {
    480: {
     pagination: { el: ".swiper-pagination", clickable: false },
     loop: false,
     slidesPerView: 3,
     grabCursor: false,
    },
   },
  });
 } else if (slidenum == 2) {
  var specialSwiper = new Swiper("#topSpecial .swiper-container", {
   slidesPerView: 1,
   watchOverflow: false,
   speed: 500,
   grabCursor: true,
   autoplay: {
    delay: 8000,
    disableOnInteraction: false,
    autoplayDisableOnInteraction: false,
   },
   loop: true,
   pagination: { el: ".swiper-pagination", clickable: true },
   spaceBetween: 15,
   breakpoints: {
    480: {
     pagination: { el: ".swiper-pagination", clickable: false },
     loop: false,
     slidesPerView: 2,
     grabCursor: false,
    },
   },
  });
 } else {
  var specialSwiper = new Swiper("#topSpecial .swiper-container", {
   slidesPerView: 1,
   pagination: { el: ".swiper-pagination", clickable: true },
   watchOverflow: false,
   loop: true,
   speed: 500,
   grabCursor: true,
   autoplay: {
    delay: 8000,
    disableOnInteraction: false,
    autoplayDisableOnInteraction: false,
   },
   spaceBetween: 15,
   breakpoints: {
    480: {
     pagination: { el: ".swiper-pagination", clickable: false },
     loop: false,
     slidesPerView: 3,
     grabCursor: false,
    },
   },
  });
 }
});
